import { useDispatch, useSelector } from 'react-redux';

import { setSchoolProcess, getSchool, setSchoolUiSettingsProcess } from 'features/school/redux/slice';
import { SchoolAutoDiscoverApiResponse, SchoolUiSettings, UseSchoolState } from './types';

const useSchool = (): UseSchoolState => {
  const school = useSelector(getSchool);
  const dispatch = useDispatch();

  const setSchool = (props: SchoolAutoDiscoverApiResponse) => {
    dispatch(setSchoolProcess(props));
  };

  const setSchoolUiSettings = (props: Partial<SchoolUiSettings>) => {
    dispatch(setSchoolUiSettingsProcess(props));
  };

  return {
    ...school,
    setSchool,
    setSchoolUiSettings,
  };
};

export default useSchool;
